const ButtonColors = {
  DEFAULT: "default",
  PRIMARY: "primary",
  DANGER: "danger",
};

export default ButtonColors;
